import React from "react";
import { Row, Col, Card, Button } from "antd";
import { useHistory } from "react-router-dom";
import AdminBreadCrumb from "components/AdminBreadCrumb";
import {
  BarChartOutlined,
  ExperimentOutlined,
  FileTextOutlined,
  DollarOutlined,
  WarningOutlined,
  InboxOutlined,
  CloudUploadOutlined,
  PhoneOutlined
} from "@ant-design/icons";
import "./ReportsDashboard.scss";

const breadCrumbs = [{ text: "REPORTS" }];

const ReportsDashboard = () => {
  const history = useHistory();

  const handleCardClick = (path) => {
    if (path) {
      history.push(path);
    }
  };

  const reportCards = [
    {
      title: "Billing Reports",
      description: "View billing and invoicing reports",
      icon: <DollarOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: "/admin/billing/reports",
      available: true
    },
    {
      title: "Pool Report",
      description: "View pool packages by package type and client",
      icon: <InboxOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: "/admin/reports/pool",
      available: true
    },
    {
      title: "Failed Stops Analysis",
      description: "Analyze failed delivery stops and patterns",
      icon: <WarningOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: "/admin/reports/failed-stop-analysis",
      available: true
    },
    {
      title: "SFTP POD Logs",
      description: "View and export SFTP Proof-of-Delivery upload log entries",
      icon: <CloudUploadOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: "/admin/reports/sftp-pod-logs",
      available: true
    },
    {
      title: "Driver Call Logs",
      description:
        "Calls and texts drivers made to stop contacts, with time away from the app",
      icon: <PhoneOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: "/admin/reports/driver-call-logs",
      available: true
    },
    {
      title: "Route Analytics",
      description: "Analyze route performance and efficiency metrics",
      icon: <BarChartOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: null,
      available: false
    },
    {
      title: "Customer Insights",
      description: "Customer behavior and satisfaction reports",
      icon: <FileTextOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: null,
      available: false
    }
    /*{
      title: "Performance Dashboard",
      description: "Overall business performance metrics",
      icon: <ExperimentOutlined style={{ fontSize: "32px", color: "#1890ff" }} />,
      path: null,
      available: false
    }*/
  ];

  return (
    <div className="reports-dashboard">
      <AdminBreadCrumb breadCrumbs={breadCrumbs} />

      <div className="reports-dashboard-content">
        <div className="reports-header">
          <h1 style={{ color: "#1890ff", marginBottom: "8px" }}>Reports Dashboard</h1>
          <p style={{ color: "#666", marginBottom: "32px" }}>
            Access comprehensive analytics and business intelligence reports
          </p>
        </div>

        <Row gutter={[24, 24]}>
          {reportCards.map((card, index) => (
            <Col xs={24} sm={12} md={12} lg={6} key={index}>
              <Card
                className={`report-card ${card.available ? "available" : "coming-soon"}`}
                hoverable={card.available}
                onClick={() => handleCardClick(card.path)}
                style={{
                  height: "200px",
                  cursor: card.available ? "pointer" : "default",
                  opacity: card.available ? 1 : 0.6
                }}
              >
                <div className="card-content">
                  <div className="card-icon">{card.icon}</div>
                  <h3 style={{ color: "#1890ff", margin: "16px 0 8px 0" }}>
                    {card.title}
                  </h3>
                  <p style={{ color: "#666", fontSize: "14px", marginBottom: "16px" }}>
                    {card.description}
                  </p>
                  {card.available ? (
                    <Button type="primary" style={{ marginTop: "auto" }}>
                      View Report
                    </Button>
                  ) : (
                    <Button disabled style={{ marginTop: "auto" }}>
                      Coming Soon
                    </Button>
                  )}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default ReportsDashboard;
